
export function recursivelyFindingNavigationItem (items, selectedItemId) {
  if (!items) {
    return
  }
  let navigationItem = items.find(item => item.$ID === selectedItemId)
  if (navigationItem) {
    return navigationItem
  }
  let foundNavigationItem = undefined
  for (let index in items) {
    foundNavigationItem = recursivelyFindingNavigationItem(items[index].Items, selectedItemId)
    if (foundNavigationItem) {
      return foundNavigationItem
    }
  }

  return foundNavigationItem
}